import { render } from "./robot-market.vue?vue&type=template&id=331e52fc&scoped=true"
import script from "./robot-market.vue?vue&type=script&lang=js"
export * from "./robot-market.vue?vue&type=script&lang=js"

import "./robot-market.vue?vue&type=style&index=0&id=331e52fc&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331e52fc"]])

export default __exports__